/**
 * @file    banner
 * @author 丁聪
 */

import React, { Component } from 'react'
import './index.scss'

class Banner extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount() { }

    render() {
        return (
            <div id="banner">
                {/* <div className="text">
                    &emsp; 文化传播 语言先行
                   <br />
                    <br />
                   &emsp; 加入<span>哈兔</span> 合作共赢
               </div> */}

            </div>
        )
    }
}

export default Banner
